var _rect, _circle, _circle2, _circle3, _line, _line2, _line3, _text, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroservicesPlatform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "msBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#172b4d"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 20,
    fill: "url(#msBg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 75,
    r: 18,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 75,
    r: 18,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 130,
    r: 18,
    fill: "rgba(255,255,255,0.12)",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 75,
    x2: 122,
    y2: 75,
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 90,
    x2: 90,
    y2: 116,
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 90,
    x2: 110,
    y2: 116,
    stroke: "rgba(255,255,255,0.45)",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 80,
    fontFamily: "Arial",
    fontSize: 11,
    fill: "white",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "API")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 80,
    fontFamily: "Arial",
    fontSize: 11,
    fill: "white",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "MQ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 135,
    fontFamily: "Arial",
    fontSize: 11,
    fill: "white",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "DB")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 170,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fill: "rgba(255,255,255,0.6)",
    textAnchor: "middle",
    letterSpacing: 1
  }, "MICROSERVICES")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroservicesPlatform);
export default __webpack_public_path__ + "static/media/microservices-platform.3cddf2a7f3fe4b27b9a9425a686a25fd.svg";
export { ForwardRef as ReactComponent };